import {apiClient} from "../../connection/BlinkApiClient.js";
import {loadVersionedObjectFromResponse} from "../misc/StoreUtils";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {MerchantSDKResource} from "../misc/MerchantSDKResource.js";
import {BaseStore, globalStore} from "../../../stem-core/state/Store.js";


@globalStore
export class MerchantPanel extends BaseStore("MerchantPanel", {}, MerchantSDKResource) {
    declare alias: string;
    declare options: any;
    declare name: string;

    isBasePanel(): boolean {
        return this.alias === "base" || Object.values(PANEL_TYPE).indexOf(this.alias) >= 0 && this.alias !== PANEL_TYPE.custom;
    }

    getParentPanel(): MerchantPanel | null {
        return this.getStore().getByIdOrAlias(this.options.parentPanel);
    }

    usesPanel(panel: MerchantPanel): boolean {
        const parentPanel = this.getParentPanel();
        if (parentPanel == null) {
            return false;
        }
        return parentPanel === panel || parentPanel.usesPanel(panel);
    }
}

interface PanelData {
    [key: string]: any;
    panelId?: string;
}

export async function apiCreateMerchantPanel(data: PanelData): Promise<any> {
    const response = await apiClient.post("/merchant/create_panel", data);
    return loadVersionedObjectFromResponse(MerchantPanel, response, null);
}

export async function apiEditMerchantPanel(data: PanelData): Promise<any> {
    const response = await apiClient.post("/merchant/edit_panel", data);
    return loadVersionedObjectFromResponse(MerchantPanel, response, data.panelId);
}

export async function apiDeleteMerchantPanel(data: PanelData): Promise<any> {
    return apiClient.post("/merchant/delete_panel", data);
}

function getPanelOrderIndex(panel: MerchantPanel): number {
    if (!panel.isBasePanel()) {
        return 3;
    }
    if (panel.alias !== "base") {
        return 2;
    }
    return 1;
}

export function panelSortCompareFn(panel1: MerchantPanel, panel2: MerchantPanel): number {
    if (getPanelOrderIndex(panel1) !== getPanelOrderIndex(panel2)) {
        return getPanelOrderIndex(panel1) - getPanelOrderIndex(panel2);
    }
    return panel1.name < panel2.name ? -1 : 1;
}
